import { getCommunityPermissions } from './getCommunityPermissions'
import type { TPermissionKey, TPermissionsMap } from './permissions'

export const isGranted = (permission: TPermissionKey, permissionsMap: TPermissionsMap): boolean => {
  if (!permissionsMap) {
    throw new Error('PermissionsMap not provided')
  }

  const userPermissions = getCommunityPermissions(permissionsMap)
  return !!userPermissions[permission]
}
